import React from 'react';
import {Redirect} from 'react-router-dom';

export default function Logout({match}) {
    sessionStorage.setItem("user_level","-1");
    return <Redirect to="/mgt/login" />
}